import axios from './axios';
import config from '../../helpers/config';

export default (designIds, customerName, email, message, dcName, dcEmail, dcPhone, dcExtension) => (
  axios.post(
    config.designBuilderShareEstimate,
    {
      To: email,
      Subject: '',
      Body: message,
      Designs: designIds,
      AdditionalParameters: {
        CustomerName: customerName,
        DCName: dcName,
        DCEmail: dcEmail,
        DCPhone: dcPhone,
        DCExtension: dcExtension,
      },
    },
  )
);
